import { Marketday } from './';
import {JsonProperty} from 'json-typescript-mapper';

export class Energyflat {
  @JsonProperty('id')
  public id?: number;

  @JsonProperty('marketdayNumber')
  public marketdayNumber?: string;

  @JsonProperty('validFrom')
  public validFrom?: string;

  @JsonProperty('priceType')
  public priceType?: string;

  @JsonProperty('priceLow')
  public priceLow?: number;

  @JsonProperty('priceNormal')
  public priceNormal?: number;

  @JsonProperty('priceSpecial')
  public priceSpecial?: number;

  @JsonProperty('updated')
  public updated?: string;

  @JsonProperty('created')
  public created?: string;

  @JsonProperty('gguid')
  public gguid?: string;

  @JsonProperty({clazz: Marketday, name: 'marketday'})
  public marketday?: Marketday;

  constructor() {
    this.id = void 0;
    this.marketdayNumber = void 0;
    this.validFrom = void 0;
    this.priceType = void 0;
    this.priceLow = void 0;
    this.priceNormal = void 0;
    this.priceSpecial = void 0;
    this.updated = void 0;
    this.created = void 0;
    this.gguid = void 0;
    this.marketday = void 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/energyflat.model.ts